import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';
import { AdminHeader } from '../admin-header/admin-header';

const baseUrl = 'https://logs.proofile.com.ng/api';

@Component({
  selector: 'app-report',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminSidebar, AdminHeader],
  templateUrl: './reports.html',
  styleUrls: ['./reports.css']
})
export class ReportComponent implements OnInit {
  reportData: any[] = [];
  drugs: any[] = [];
  stores: any[] = [];

  search = {
    drug: '',
    store: '',
    patientType: '',
    fromDate: '',
    toDate: ''
  };

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.fetchDrugs();
    this.fetchStores();
    this.fetchReports();
  }

  fetchDrugs() {
    this.http.get<any[]>(`${baseUrl}/stock-items`).subscribe(data => {
      this.drugs = data;
    });
  }

  fetchStores() {
    this.http.get<any[]>(`${baseUrl}/stores`).subscribe(data => {
      this.stores = data;
    });
  }

  fetchReports() {
    const params = new HttpParams()
      .set('drug', this.search.drug)
      .set('store', this.search.store)
      .set('patientType', this.search.patientType)
      .set('from', this.search.fromDate)
      .set('to', this.search.toDate);

    this.http.get<any[]>(`${baseUrl}/reports`, { params }).subscribe(data => {
      this.reportData = data;
    });
  }
}
